import React, { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";

import ModalComponent from "../../components/Modals/Modal";

import ContactInfoScreen from "./VisionBookingScreen/ContactInfoScreen";
import { useDispatch, useSelector } from "react-redux";
import { generateBookingLogs } from "../../Utilities/general";

import { useNavigate, useLocation } from "react-router";
import { getAllDeliverySlots } from "../../store/actions/deliverySlotsActions";
import { getAllVehicles } from "../../store/actions/vehicleTypeActions";
import { userPaymentMethods } from "../../store/actions/paymentActions";
import BookingProgress from "../../components/Booking/BookingProgress";

import {
  createVisionBooking,
  GetBookingPriceEstimate,
  getMovingItems,
  saveVisionDataToBackend,
  updateVisionBooking,
} from "../../store/actions/visionAgentActions";
import UploadImagesScreen from "./VisionBookingScreen/UploadImagesScreen";
import DateAndTimeScreen from "./VisionBookingScreen/DateAndTimeScreen";
import VisionItemsScreen from "./VisionBookingScreen/VisionItemsScreen";
import LocationScreen from "./VisionBookingScreen/LocationScreen";
import PersonalInfoScreen from "./VisionBookingScreen/PersonalInfoScreen";
import AddTextModal from "../../components/Modals/AddtextModal";
import { useToaster } from "../../components/Toaster";
import BookingTotal from "../../components/Booking/BookingTotal";
import useIsMobileDevice from "../../hooks/useIsMobileDevice";
import NavigationWithEstimate from "../../components/Booking/NavigationWithEstimate";
import ReusableModal from "../../components/Booking/ReusableModal";
import { suggestedVehicleAndLabour } from "../../store/actions/vehicleTypeActions";
import { useAtom } from "jotai";
import { isMapShownAtom } from "../../jotai-store/isMapShow";
import SummaryScreen from "./VisionBookingScreen/SummaryScreen";
import NoBoxesAndBagsWarningModal from "../../components/Booking/NoBoxesAndBagsWarningModal";
import NotATruckModal from "../../components/Booking/NotATruckModal";
import LoadingMoveez from "../../components/Lottie/LoadingMoveez";
import VehicleScreen from "./VisionBookingScreen/VehicleScreen";
import BookOneMoverWarnModal from "../../components/Booking/BookOneMoverWarnModal";
import { createBookingPayload } from "../../store/actions/bookingActions";
import { getVisionBookingByVisionId } from "../../store/actions/visionAgentActions";
import { visionSignup } from "../../store/actions/profileInfoActions";
import { getUserProfile } from "../../store/actions/userProfileActions";
import toDeliveryDateFormat from "../../Utilities/dateConverter";
import { getEditModeDeliveryDate } from "../../Utilities/deliveryDateHelpers";
import { v4 as uuidv4 } from "uuid";

const Booking = () => {
  const history = useNavigate();
  const [showPreview, setShowPreview] = useState(false);
  const [errorObject, setErrorObject] = useState({});
  const [items, setItems] = useState([]);
  const [boxAndBagsCount, setBoxAndBagsCount] = useState(0);
  const [pickupLocation, setPickupLocation] = useState("");
  const [pickupLatitude, setPickupLatitude] = useState("");
  const [pickupLongitude, setPickupLongitude] = useState("");
  const [dropoffLocation, setDropoffLocation] = useState("");
  const [dropoffLatitude, setDropoffLatitude] = useState("");
  const [dropoffLongitude, setDropoffLongitude] = useState("");
  const [vehicleTypeId, setVehicleTypeId] = useState(1002);
  const [vehicle, setVehicle] = useState({});
  const [selectedVehicleName, setSelectedVehicleName] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [type, setType] = useState("Moving");
  const [deliverySlotId, setDeliverySlotId] = useState(1000);
  const [exactTime, setExactTime] = useState("");
  const { showToast } = useToaster();
  const [labourNeeded, setLabourNeeded] = useState(1);
  const [totalOverweightItems, setTotalOverweightItems] = useState(0);
  const [estimatedTime, setEstimatedTime] = useState(0);
  const [pickupTotalFloors, setPickupTotalFloors] = useState(0);
  const [dropoffTotalFloors, setDropoffTotalFloors] = useState(0);
  const [pickupMedium, setPickupMedium] = useState("");
  const [dropoffMedium, setDropoffMedium] = useState("");
  const [distanceInKm, setDistanceInKm] = useState(0);
  const [durationInMins, setDurationInMins] = useState(0);
  const [bookingSizeId, setBookingSizeId] = useState(1);
  const [dropOffPersonName, setDropOffPersonName] = useState("");
  const [dropOffPersonPhone, setDropOffPersonPhone] = useState("");
  const [pickUpPersonName, setPickUpPersonName] = useState("");
  const [pickUpPersonPhone, setPickUpPersonPhone] = useState("");
  const [dropOffInstructions, setDropOffInstructions] = useState("");
  const [pickUpInstructions, setPickUpInstructions] = useState("");
  const [tripStatus, setTripStatus] = useState("");
  const [status, setStatus] = useState("");
  const [pickupNoOfStairs, setPickupNoOfStairs] = useState(1);
  const [dropoffNoOfStairs, setDropoffNoOfStairs] = useState(1);
  const [pickupNoOfFloors, setPickupNoOfFloors] = useState(1);
  const [dropoffNoOfFloors, setDropoffNoOfFloors] = useState(1);
  const [userId, setUserId] = useState(0);
  const [numberOfHours, setNumberOfHours] = useState(1);
  const [stops, setStops] = useState([]);
  const [isDeliverNow, setIsDeliverNow] = useState(false);
  const [isHalfLoad, setIsHalfLoad] = useState(false);
  const [bookingTotalModel, setBookingTotalModel] = useState({});
  const [estimatePricing, setEstimatePricing] = useState({});
  const [estimatePricingLoad, setEstimatePricingLoad] = useState(false);
  const [completeBookingObj, setCompleteBookingObj] = useState({});
  const [refreshTrigger, setRefreshTrigger] = useState(0); // manual trigger
  const [coupon, setCoupon] = useState("");
  const [isTruckRequired, setIsTruckRequired] = useState(true);
  const [noBoxesAndBagsWarningModalOpen, setNoBoxesAndBagsWarningModalOpen] =
    useState(false);
  const [bookOneMoverWarnModalOpen, setBookOneMoverWarnModalOpen] =
    React.useState(false);
  const [isNotATruckModalOpen, setIsNotATruckModalOpen] = React.useState(false);
  const [isTruckAndMooverWarningSeen, setIsTruckAndMooverWarningSeen] =
    useState(false);

  //
  //
  // DEFINING
  // VARIABLES
  //
  //

  // dispatch redux actions // IsMobile ? Hook
  const dispatch = useDispatch();
  const isMobileDevice = useIsMobileDevice();
  const [isOpen, setIsOpen] = useState(false);
  const [bookingStep, setBookingStep] = useState(0);
  const [sliderVehicles, setSliderVehicles] = useState([]);
  const [isMapShown, setIsMapShown] = useAtom(isMapShownAtom);
  // vision states
  const [visionData, setVisionData] = useState();
  const [selectedBookingItemIndex, setSelectedBookingItemIndex] = useState(0);
  const [openAddNoteModal, setOpenAddNoteModal] = useState(false);
  const [addItems, setAddItems] = useState(false);
  const [bookingItemsCatlog, setBookingItemsCatlog] = useState([]);
  const [frontItems, setFrontItems] = useState({});
  const [selectedBookingItemsFromCatlog, setSelectedBookingItemsFromCatlog] =
    useState([]);
  const [visionItemsLoading, setVisionItemsLoading] = useState(false);
  const [updatedAt, setUpdatedAt] = useState(new Date().toISOString());
  const [visionProcessingStartTime, setVisionProcessingStartTime] =
    useState(null);
  const [showVisionTimeoutError, setShowVisionTimeoutError] = useState(false);
  const [showGenericModal, setShowGenericModal] = useState(false);
  const [genericModalMessage, setGenericModalMessage] = useState("");
  const [showPaymentMessage, setShowPaymentMessage] = useState(false);
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const [generalLoading, setGeneralLoading] = useState(false);
  const [isLocationRouteComputing, setIsLocationRouteComputing] =
    useState(false);

  const [justRegisteredFromPersonalInfo, setJustRegisteredFromPersonalInfo] =
    useState(() => {
      try {
        return localStorage.getItem("just_registered") === "true";
      } catch (e) {
        return false;
      }
    });

  // Important: visionId after saving to backend
  const [visionId, setVisionId] = useState();

  //Modal consts
  const [Dateopen, setDateOpen] = React.useState(false);
  const handleDateClose = () => setDateOpen(false);

  // Vehicle state
  const [vehicleId, setVehicleId] = useState(0);

  //
  //
  // GETTING STATES FROM REDUX
  //
  //
  // getting vehicle info
  const { vehicleTypesInfo } = useSelector(
    (state) => state.vehicleTypesReducer,
  );

  // Getting delivery slots
  const { deliverySlotsInfo } = useSelector(
    (state) => state.deliverySlotsReducer,
  );

  // getting user details from reducer
  const { loginInfo } = useSelector((state) => state.loginReducer);

  //Personal Info Screen user details
  const [firstName, setFirstName] = useState(loginInfo?.firstName || "");
  const [lastName, setLastName] = useState(loginInfo?.lastName || "");
  const [email, setEmail] = useState(loginInfo?.email || "");
  const [phone, setPhone] = useState(loginInfo?.phone || "");

  // Keep local personal-info state in sync with redux `loginInfo`.
  // This ensures values populate after a page refresh when `loginInfo`
  // becomes available asynchronously.
  useEffect(() => {
    try {
      setFirstName(loginInfo?.firstName ?? "");
      setLastName(loginInfo?.lastName ?? "");
      setEmail(loginInfo?.email ?? "");
    } catch (e) {
      console.error("Failed to sync loginInfo to local state", e);
    }
  }, [loginInfo]);

  //
  //
  // FUNCTIONS
  //
  //
  //

  const bookingObjToStates = (bookingObj) => {
    setItems(Array.isArray(bookingObj?.items) ? bookingObj?.items : []);
    setPickupLocation(bookingObj?.pickupLocation ?? "");
    setPickupLatitude(bookingObj?.pickupLatitude ?? "");
    setPickupLongitude(bookingObj?.pickupLongitude ?? "");
    setDropoffLocation(bookingObj?.dropoffLocation ?? "");
    setDropoffLatitude(bookingObj?.dropoffLatitude ?? "");
    setDropoffLongitude(bookingObj?.dropoffLongitude ?? "");
    setVehicleTypeId(bookingObj?.vehicleTypeId);
    setVehicle(bookingObj?.vehicle ?? {});
    setType(bookingObj?.type ?? "Moving");
    setDeliveryDate(bookingObj?.deliveryDate ?? "");
    setDeliverySlotId(bookingObj?.deliverySlotId ?? 1000);
    setExactTime(bookingObj?.exactTime ?? "");
    setLabourNeeded(bookingObj?.labourNeeded ?? 1);
    setTotalOverweightItems(bookingObj?.totalOverweightItems ?? 0);
    setEstimatedTime(bookingObj?.estimatedTime ?? 0);
    setPickupTotalFloors(bookingObj?.pickupTotalFloors ?? 0);
    setDropoffTotalFloors(bookingObj?.dropoffTotalFloors ?? 0);
    setPickupMedium(bookingObj?.pickupMedium ?? "");
    setDropoffMedium(bookingObj?.dropoffMedium ?? "");
    setDistanceInKm(bookingObj?.distanceInKm ?? 0);
    setDurationInMins(bookingObj?.durationInMins ?? 0);
    setBookingSizeId(bookingObj?.bookingSizeId ?? 1);
    setDropOffPersonName(bookingObj?.dropOffPersonName ?? "");
    setDropOffPersonPhone(bookingObj?.dropOffPersonPhone ?? "");
    setPickUpPersonName(bookingObj?.pickUpPersonName ?? "");
    setPickUpPersonPhone(bookingObj?.pickUpPersonPhone ?? "");
    setDropOffInstructions(bookingObj?.dropOffInstructions ?? "");
    setPickUpInstructions(bookingObj?.pickUpInstructions ?? "");
    setTripStatus(bookingObj?.tripStatus ?? "");
    setStatus(bookingObj?.status ?? "");
    setUserId(bookingObj?.userId ?? 0);
    setNumberOfHours(bookingObj?.numberOfHours ?? 1);
    setStops(bookingObj?.stops ?? []);
    setIsDeliverNow(bookingObj?.isDeliverNow ?? true);
    setIsHalfLoad(bookingObj?.isHalfLoad ?? false);
    setCoupon(bookingObj?.coupon ?? "");
    setPickupNoOfStairs(bookingObj?.pickupNoOfStairs ?? 1);
    setPickupNoOfFloors(bookingObj?.pickupNoOfFloors ?? 1);
    setDropoffNoOfStairs(bookingObj?.dropoffNoOfStairs ?? 1);
    setDropoffNoOfFloors(bookingObj?.dropoffNoOfFloors ?? 1);
    setSelectedVehicleName(bookingObj?.SelectedVehicleName ?? "");
    setIsTruckRequired(bookingObj?.isTruckRequired ?? true);
    setBoxAndBagsCount(bookingObj?.boxAndBagsCount ?? 0);
    setUpdatedAt(bookingObj?.updatedAt ?? new Date().toISOString());
  };

  const statesToBookingObj = () => {
    return {
      // bookingId,
      pickupLocation,
      pickupLatitude,
      pickupLongitude,
      dropoffLocation,
      dropoffLatitude,
      dropoffLongitude,
      vehicleTypeId,
      vehicle,
      deliveryDate,
      type,
      deliverySlotId,
      exactTime,
      labourNeeded,
      totalOverweightItems,
      estimatedTime,
      pickupTotalFloors,
      dropoffTotalFloors,
      pickupMedium,
      dropoffMedium,
      distanceInKm,
      durationInMins,
      bookingSizeId,
      dropOffPersonName,
      dropOffPersonPhone,
      pickUpPersonName,
      pickUpPersonPhone,
      SelectedVehicleName: selectedVehicleName,
      dropOffInstructions,
      pickUpInstructions,
      tripStatus,
      status,
      userId: loginInfo?.id ?? userId,
      numberOfHours,
      stops,
      isDeliverNow,
      isHalfLoad,
      coupon,
      pickupNoOfStairs,
      pickupNoOfFloors,
      dropoffNoOfStairs,
      dropoffNoOfFloors,
      items,
      boxAndBagsCount,
      isTruckRequired,
      updatedAt,
    };
  };

  const saveBookingInLS = (name, value, triggeredBy, updatedBooking) => {
    const oldBooking = JSON.parse(localStorage.getItem("VBO")) || {};
    const merged = {
      ...oldBooking,
      ...updatedBooking, // tripStatus, items, everything
      updatedAt: new Date().toISOString(),
    };
    localStorage.setItem("VBO", JSON.stringify(merged));
    setUpdatedAt(merged.updatedAt);
    generateBookingLogs(name, value, merged, triggeredBy, `VBO`);
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emailRegex.test(email);
  };

  // Account creation logic
  const onCreateAccount = async () => {
    if (loginInfo && loginInfo?.id && loginInfo?.id > 0) {
      // User already logged in
      return true;
    }
    // Email validation
    if (!isValidEmail(email)) {
      showToast({
        type: "info",
        message: "Please enter a valid email address.",
        duration: 4500,
      });
      return false;
    }

    // Required fields check
    const allFilled = [firstName, lastName, email, phone].every(
      (v) => String(v).trim() !== "",
    );

    if (!allFilled) {
      showToast({
        type: "info",
        message: "Please fill in all required fields.",
        duration: 4500,
      });
      return false;
    }

    try {
      setGeneralLoading(true);
      const userResponse = await visionSignup({
        firstName,
        lastName,
        email,
        phone,
      });

      // Success case (200 / 201)
      if (
        userResponse?.statusCode === 200 ||
        userResponse?.statusCode === 201
      ) {
        const currentUserEmail = userResponse.data.email;

        dispatch(getUserProfile(currentUserEmail));

        showToast({
          type: "success",
          message: "Account created successfully!",
          duration: 4500,
        });

        // Advance to Contact Info step only after successful signup
        try {
          handleUpdateBookingObject(
            "tripStatus",
            "ContactInfo",
            "onCreateAccount_success",
          );
        } catch (e) {
          console.warn("Could not update tripStatus after signup:", e);
        }
        return true;
      }

      // Unexpected response
      showToast({
        type: "error",
        message: "Unexpected response from server. Please try again.",
        duration: 4500,
      });

      return false;
    } catch (error) {
      console.log("FULL ERROR:", error);

      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data ||
        "Account creation failed, please try again later!";

      showToast({
        type: "error",
        message: backendMessage,
        duration: 4500,
      });

      return false;
    } finally {
      setGeneralLoading(false);
    }
  };

  const resetAllStatesToDefault = () => {
    setItems([]);
    setPickupLocation("");
    setPickupLatitude("");
    setPickupLongitude("");
    setDropoffLocation("");
    setDropoffLatitude("");
    setDropoffLongitude("");
    setVehicleTypeId(1002);
    setVehicle({});
    setDeliveryDate("");
    setType("Moving");
    setDeliverySlotId(1000);
    setExactTime("");
    setLabourNeeded(1);
    setTotalOverweightItems(0);
    setEstimatedTime(0);
    setPickupTotalFloors(0);
    setDropoffTotalFloors(0);
    setPickupMedium("");
    setDropoffMedium("");
    setDistanceInKm(0);
    setDurationInMins(0);
    setBookingSizeId(1);
    setDropOffPersonName("");
    setDropOffPersonPhone("");
    setPickUpPersonName("");
    setPickUpPersonPhone("");
    setDropOffInstructions("");
    setPickUpInstructions("");
    setTripStatus("");
    setStatus("");
    setUserId(0);
    setNumberOfHours(1);
    setStops([]);
    setIsDeliverNow(false);
    setIsHalfLoad(false);
    setCoupon("");
    setPickupNoOfStairs(1);
    setPickupNoOfFloors(1);
    setDropoffNoOfStairs(1);
    setDropoffNoOfFloors(1);
    setIsTruckRequired(true);
    setUpdatedAt(new Date().toISOString());
    // Do NOT reset bookingId here, so it persists if set from API/localStorage
  };

  const checkAndClearExpiredBooking = (bookingObj) => {
    if (!bookingObj?.updatedAt) {
      // If no updatedAt field exists, consider it expired and reset
      resetAllStatesToDefault();
      localStorage.removeItem("VBO");
      localStorage.removeItem("VBItems");
      return true;
    }

    const updatedAtTime = new Date(bookingObj.updatedAt);
    const currentTime = new Date();
    const timeDifferenceInHours =
      (currentTime - updatedAtTime) / (1000 * 60 * 60);

    // Check if booking is older than 8 hours
    if (timeDifferenceInHours > 8) {
      resetAllStatesToDefault();
      localStorage.removeItem("VBO");
      localStorage.removeItem("VBItems");
      return true; // Booking expired and cleared
    }

    return false; // Booking is still valid
  };

  const updateItemsAndTimestamp = (newItems) => {
    setItems(newItems);
    localStorage.setItem("VBItems", JSON.stringify(newItems));

    const oldBooking = JSON.parse(localStorage.getItem("VBO")) || {};
    const updatedBooking = {
      ...oldBooking,
      items: newItems,
      updatedAt: new Date().toISOString(),
    };

    saveBookingInLS("items", newItems, "items_update", updatedBooking);
  };

  const updateBookingStateBasedOnName = (name, value) => {
    if (!name) return;
    switch (name) {
      case "bookingId":
        // setBookingId(value);
        break;
      case "items":
        setItems(value);
        break;
      case "pickupLocation":
        setPickupLocation(value);
        // If pickup location cleared, reset related medium and stairs
        if (!value || (typeof value === "string" && value.trim() === "")) {
          setPickupMedium("");
          setPickupNoOfStairs(1);
          setPickupNoOfFloors(1);
        }
        break;
      case "pickupLatitude":
        setPickupLatitude(value);
        break;
      case "pickupLongitude":
        setPickupLongitude(value);
        break;
      case "dropoffLocation":
        setDropoffLocation(value);
        // If dropoff location cleared, reset related medium and stairs
        if (!value || (typeof value === "string" && value.trim() === "")) {
          setDropoffMedium("");
          setDropoffNoOfStairs(1);
          setDropoffNoOfFloors(1);
        }
        break;
      case "dropoffLatitude":
        setDropoffLatitude(value);
        break;
      case "dropoffLongitude":
        setDropoffLongitude(value);
        break;
      case "vehicleTypeId":
        setVehicleTypeId(value);
        break;
      case "vehicle":
        setVehicle(value);
        break;
      case "deliveryDate":
        setDeliveryDate(value);
        break;
      case "deliverySlotId":
        setDeliverySlotId(value);
        break;
      case "type":
        setType(value);
        break;
      case "exactTime":
        setExactTime(value);
        break;
      case "labourNeeded":
        setLabourNeeded(value);
        break;
      case "totalOverweightItems":
        setTotalOverweightItems(value);
        break;
      case "estimatedTime":
        setEstimatedTime(value);
        break;
      case "pickupTotalFloors":
        setPickupTotalFloors(value);
        break;
      case "dropoffTotalFloors":
        setDropoffTotalFloors(value);
        break;
      case "pickupMedium":
        setPickupMedium(value);
        // If elevator is unselected, reset elevator floor counter to default
        if (!value || value.toString().toLowerCase() !== "elevator")
          setPickupNoOfFloors(1);
        break;
      case "dropoffMedium":
        setDropoffMedium(value);
        // If elevator is unselected, reset elevator floor counter to default
        if (!value || value.toString().toLowerCase() !== "elevator")
          setDropoffNoOfFloors(1);
        break;
      case "distanceInKm":
        setDistanceInKm(value);
        break;
      case "durationInMins":
        setDurationInMins(value);
        break;
      case "bookingSizeId":
        setBookingSizeId(value);
        break;
      case "dropOffPersonName":
        setDropOffPersonName(value);
        break;
      case "dropOffPersonPhone":
        setDropOffPersonPhone(value);
        break;
      case "pickUpPersonName":
        setPickUpPersonName(value);
        break;
      case "pickUpPersonPhone":
        setPickUpPersonPhone(value);
        break;
      case "dropOffInstructions":
        setDropOffInstructions(value);
        break;
      case "pickUpInstructions":
        setPickUpInstructions(value);
        break;
      case "tripStatus":
        setTripStatus(value);
        break;
      case "status":
        setStatus(value);
        break;
      case "userId":
        setUserId(value);
        break;
      case "numberOfHours":
        setNumberOfHours(value);
        break;
      case "stops":
        setStops(JSON.parse(JSON.stringify(value)));
        break;
      case "isDeliverNow":
        setIsDeliverNow(value);
        break;
      case "isTruckRequired":
        setIsTruckRequired(value);
        break;
      case "isHalfLoad":
        setIsHalfLoad(value);
        break;
      case "coupon":
        setCoupon(value);
        break;
      case "pickupNoOfStairs":
        setPickupNoOfStairs(value);
        break;
      case "pickupNoOfFloors":
        setPickupNoOfFloors(value);
        break;
      case "dropoffNoOfStairs":
        setDropoffNoOfStairs(value);
        break;
      case "dropoffNoOfFloors":
        setDropoffNoOfFloors(value);
        break;
      case "boxAndBagsCount":
        setBoxAndBagsCount(value);
        break;
      case "SelectedVehicleName":
        setSelectedVehicleName(value);
        break;
      case "updatedAt":
        setUpdatedAt(value);
        break;
      default:
        break;
    }
  };

  const handleSaveImagesToBackend = async () => {
    // Check if already processed
    const existingVisionId = localStorage.getItem("visionReqId");
    if (existingVisionId) {
      setVisionId(existingVisionId);
      setIsMapShown(true);
      return true;
    }
    setGeneralLoading(true);
    try {
      const result = await saveVisionDataToBackend();

      if (result.isSuccess) {
        // UUID assign karna agar backend se unique IDs nahi aa rahi
        const updatedItems = result.newItems.map((item) => ({
          ...item,
          itemId: item.itemId || uuidv4(),
        }));

        updateItemsAndTimestamp(updatedItems);
        setVisionId(result.visionId);
        setIsMapShown(true);

        showToast({
          type: "success",
          message: "Vision analysis completed successfully!",
        });
        return true;
      } else {
        showToast({
          type: "error",
          message: result.message || "Failed to save.",
        });
        return false;
      }
    } catch (error) {
      showToast({ type: "error", message: "A critical error occurred." });
      return false;
    } finally {
      setGeneralLoading(false);
    }
  };

  // Handle Dynamic Next Click Cases for Validation
  const handleNextClickValidations = async () => {
    const hasCoordinate = (value) => {
      if (value === null || value === undefined || value === "") return false;
      const num = Number(value);
      return Number.isFinite(num);
    };

    switch (tripStatus) {
      // ------------------- LOCATIONS SCREEN -------------------
      case "locations": {
        if (
          (isTruckRequired && !dropoffLocation?.trim()) ||
          (isTruckRequired && !dropoffMedium?.trim()) ||
          !pickupLocation?.trim() ||
          !pickupMedium?.trim() ||
          (stops.length !== 0 &&
            stops
              .map((stop) => !stop.stopMedium || stop.stopMedium.trim() === "")
              .includes(true))
        ) {
          // replace browser alert with Toaster-based notification
          try {
            showToast({
              type: "warning",
              message:
                "Please enter both pickup and drop-off locations along with their mediums.",
              duration: 4500,
            });
          } catch (e) {
            // fallback if Toaster isn't available
            alert(
              "Please enter both pickup and drop-off locations along with their mediums.",
            );
          }
          return false;
        }

        if (isLocationRouteComputing) {
          showToast({
            type: "warning",
            message:
              "Please wait while we calculate route distance and duration.",
            duration: 4500,
          });
          return false;
        }

        const pickupCoordinatesReady =
          hasCoordinate(pickupLatitude) && hasCoordinate(pickupLongitude);
        const dropoffCoordinatesReady =
          !isTruckRequired ||
          (hasCoordinate(dropoffLatitude) && hasCoordinate(dropoffLongitude));
        const routeMetricsReady =
          !isTruckRequired ||
          (Number(distanceInKm) > 0 && Number(durationInMins) > 0);

        if (
          !pickupCoordinatesReady ||
          !dropoffCoordinatesReady ||
          !routeMetricsReady
        ) {
          showToast({
            type: "warning",
            message:
              "Please wait, we are still setting route details. Try again in a moment, or go back and reselect locations.",
            duration: 4500,
          });
          return false;
        }

        return true;
      }

      // ------------------- SCHEDULE SCREEN -------------------
      case "schedule": {
        if (!deliveryDate?.trim() || !exactTime?.trim()) {
          showToast({
            type: "warning",
            message: "Please select a delivery date and time to continue.",
            duration: 4500,
          });
          return false;
        }

        return true;
      }

      // ------------------- VISION SCREEN -------------------
      case "visionItems": {
        if (!items || items.length === 0) {
          showToast({
            type: "warning",
            message: "Please select at least one movable item to proceed.",
            duration: 4500,
          });
          return false;
        }

        // --- Extra check for single "Boxes & bags" ---
        if (items.length === 1 && items[0].name === "Boxes & bags") {
          showToast({
            type: "warning",
            message:
              "Boxes & bags cannot be the only item in your booking. Please add at least one more item",
            duration: 4500,
          });
          return false;
        }

        if (!boxAndBagsCount || boxAndBagsCount === 0) {
          setNoBoxesAndBagsWarningModalOpen(true);
          return false;
        }
        setNoBoxesAndBagsWarningModalOpen(false);

        return true;
      }

      // ------------------- Vehicle SCREEN -------------------
      case "vehicle": {
        if (isTruckRequired && dropoffLocation.trim() == "") {
          showToast({
            type: "warning",
            message:
              "You selected Truck Required. Please go back and enter the drop-off location.",
            duration: 4500,
          });

          return false;
        }

        if (labourNeeded < 2) {
          setBookOneMoverWarnModalOpen(true);
          return false;
        }
        setBookOneMoverWarnModalOpen(false);
        return true;
      }

      // ------------------Personal Info SCREEN -------------------
      case "PersonalInfo": {
        if (
          firstName.trim() === "" ||
          lastName.trim() === "" ||
          email.trim() === "" ||
          phone.trim() === ""
        ) {
          showToast({
            type: "warning",
            message:
              "Please fill all the personal information fields to proceed.",
            duration: 4500,
          });
          return false;
        }
        const isSuccess = await onCreateAccount();
        return isSuccess;
      }

      // ------------------Contact Info SCREEN -------------------

      case "ContactInfo": {
        if (pickUpPersonName.trim() === "" || pickUpPersonPhone.trim() === "") {
          showToast({
            type: "warning",
            message: "Please enter a contact name and phone number to proceed.",
            duration: 4500,
          });

          return false;
        }

        return true;
      }

      // ------------------- DEFAULT -------------------
      default:
        return true;
    }
  };

  const handleUpdateBookingObject = (name, value, triggeredBy) => {
    try {
      let updatedBooking;
      if (name) {
        updateBookingStateBasedOnName(name, value);
        // Build updated booking. For coordinates we prefer merging with the
        // latest persisted `VBO` to avoid races with React state updates.
        const coordinateKeys = [
          "pickupLatitude",
          "pickupLongitude",
          "dropoffLatitude",
          "dropoffLongitude",
        ];

        if (coordinateKeys.includes(name)) {
          const oldBooking = JSON.parse(localStorage.getItem("VBO")) || {};
          updatedBooking = { ...oldBooking, [name]: value };
        } else {
          // Build updated booking from current React state, but prefer persisted
          // `VBItems` when available to avoid overwriting newer items saved by
          // background processes (e.g., vision save) with stale in-memory state.
          updatedBooking = { ...statesToBookingObj(), [name]: value };
          try {
            const persistedItems = JSON.parse(localStorage.getItem("VBItems"));
            if (Array.isArray(persistedItems) && persistedItems.length > 0) {
              // Use a fresh copy
              updatedBooking.items = [...persistedItems];
            }
          } catch (e) {
            // ignore JSON parse errors and fall back to in-memory items
          }
        }
        if (name === "vehicleTypeId") {
          const vehicle = sliderVehicles.find((v) => v.id === value);
          updatedBooking.vehicle = vehicle;
        }

        // Ensure immediate persistence for cleared locations: states update is async,
        // so explicitly set medium and stairs on the booking object when location is cleared.
        if (
          name === "pickupLocation" &&
          (!value || (typeof value === "string" && value.trim() === ""))
        ) {
          updatedBooking.pickupMedium = "";
          updatedBooking.pickupNoOfStairs = 0;
          updatedBooking.pickupNoOfFloors = 0;
        }
        if (
          name === "dropoffLocation" &&
          (!value || (typeof value === "string" && value.trim() === ""))
        ) {
          updatedBooking.dropoffMedium = "";
          updatedBooking.dropoffNoOfStairs = 0;
          updatedBooking.dropoffNoOfFloors = 0;
        }
      } else {
        bookingObjToStates(value);
        updatedBooking = value;
      }

      saveBookingInLS(name, value, triggeredBy, updatedBooking);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

  //increment/decrement functions
  const decrementBookingItem = (itemIndex) => {
    if (items[itemIndex].quantity > 1) {
      const newItems = items.map((item, i) =>
        i === itemIndex
          ? { ...item, quantity: Number(item.quantity) - 1 }
          : item,
      );
      updateItemsAndTimestamp(newItems);
    }
  };

  const incrementBookingItem = (itemIndex) => {
    if (items[itemIndex].quantity < 100) {
      const newItems = items.map((item, i) =>
        i === itemIndex
          ? { ...item, quantity: Number(item.quantity) + 1 }
          : item,
      );
      updateItemsAndTimestamp(newItems);
    }
  };

  /////////////////////////////////////////////////
  const disassemblyRequiredBookingItem = (itemIndex) => {
    const newItems = items?.map((item, i) =>
      i === itemIndex
        ? { ...item, isDisassembleRequired: !item.isDisassembleRequired }
        : item,
    );
    updateItemsAndTimestamp(newItems);
  };

  const selectCatalogItem = (catlogItem) => {
    if (
      !selectedBookingItemsFromCatlog
        .map((item) => item.itemId)
        .includes(catlogItem.itemId)
    )
      setSelectedBookingItemsFromCatlog([
        ...selectedBookingItemsFromCatlog,
        catlogItem,
      ]);
  };

  const removeCatalogItem = (catlogItem) => {
    setSelectedBookingItemsFromCatlog(
      selectedBookingItemsFromCatlog.filter(
        (item) => item.itemId !== catlogItem.itemId,
      ),
    );
  };

  const handleGetCatlogItems = () => {
    const bookedItemIds = items?.map((item) => item.name.toLowerCase());
    return bookingItemsCatlog.filter(
      (item) => !bookedItemIds.includes(item.name.toLowerCase()),
    );
  };

  /// Add Catalog Items: append selected catalog/popular items to existing items
  const handleAddCatalogItems = () => {
    // Append selected catalog/popular items to existing items
    try {
      const existingItems = items || [];
      const catalogItems = selectedBookingItemsFromCatlog || [];
      const catalogItemsFormatted = catalogItems.map((item) => ({
        ...item,
        isFromCatalog: true,
        quantity: 1,
      }));
      const newItems = [...existingItems, ...catalogItemsFormatted];
      updateItemsAndTimestamp(newItems);
      // clear selection and close modal
      setSelectedBookingItemsFromCatlog([]);
      setAddItems(false);
    } catch (e) {
      console.error("Error adding catalog items:", e);
    }
  };

  const handleAddNote = (itemIndex) => {
    setSelectedBookingItemIndex(itemIndex);
    setOpenAddNoteModal(true);
  };

  const handleRemoveNote = () => {
    const newItems = items.map((item, i) =>
      i === selectedBookingItemIndex ? { ...item, note: "" } : item,
    );

    updateItemsAndTimestamp(newItems);
    setOpenAddNoteModal(false);
  };

  const addNoteBookingItem = (note) => {
    console.log(note, selectedBookingItemIndex);
    console.log("setted items", items);

    console.log(
      "numbersofitems ? ",
      items[selectedBookingItemIndex].numberOfItems,
    );

    const newItems = items?.map((item, i) =>
      i === selectedBookingItemIndex ? { ...item, note } : item,
    );
    console.log("addnotebooking", newItems);

    updateItemsAndTimestamp(newItems);
    setOpenAddNoteModal(false);
  };

  const deleteBookingItem = (itemIndex) => {
    const tempBookingItem = items[itemIndex];

    if (tempBookingItem?.item?.isFromCatalog) {
      removeCatalogItem(tempBookingItem.item);
    }
    const newItems = items.filter((_, i) => i !== itemIndex);
    updateItemsAndTimestamp(newItems);
  };

  function parseMaxLoad(maxLoad) {
    if (!maxLoad) return 0;
    const parts = maxLoad.replace(/,/g, "").split("-");
    if (parts.length === 2) {
      const min = parseInt(parts[0], 10);
      const max = parseInt(parts[1], 10);
      return (min + max) / 2;
    }
    return parseInt(parts[0], 10) || 0;
  }

  const handlePopulateSliderVehicles = async (vId, vehicleList) => {
    const vehicles = vehicleList ?? vehicleTypesInfo;
    if (!vehicles?.length) return;
    const sortedVehicles = vehicles.sort((a, b) => {
      const loadA = parseMaxLoad(a.cargoSpace?.maxLoad);
      const loadB = parseMaxLoad(b.cargoSpace?.maxLoad);
      return loadA - loadB;
    });
    const index = sortedVehicles.findIndex(
      (item) => parseInt(item.id) === parseInt(vId ?? 0),
    );
    const slicedVehicles = sortedVehicles.slice(index < 0 ? 0 : index);
    setSliderVehicles(slicedVehicles);
    return slicedVehicles || [];
  };

  //Dynamic Funtion To Navigate Between Booking Screens
  const handleBookingScreensNavigations = (tripStatus, triggeredBy) => {
    handleUpdateBookingObject("tripStatus", tripStatus, triggeredBy);
  };

  const handleToggleGenericError = (message) => {
    setShowGenericModal(message ? true : false);
    setGenericModalMessage(message ? message : "");
  };

  const updateUserCardStatus = () => {
    try {
      let user = localStorage.getItem("wemoovezUserProfile");
      if (user) {
        user = JSON.parse(user);
        userPaymentMethods(user.id);
      }
    } catch (e) {
      Sentry.captureException(e);
    }
  };

  const handleSelectVehicleInSlider = () => {
    const index = sliderVehicles?.findIndex(
      (vehicle) => vehicle?.id === vehicleTypeId,
    );
    const ch_id = index >= 0 ? index : 0;
    let theDot = document.getElementById(`vehicleSliderDot${ch_id}`);
    theDot?.click();
  };

  const handleSuggestedVehicleAndLabour = async () => {
    try {
      setGeneralLoading(true);

      const { vehicleResult, labourResult } = await suggestedVehicleAndLabour(
        isTruckRequired,
        items,
        {
          pickupMedium,
          dropoffMedium,
          distance: distanceInKm,
        },
      );

      let vehicleTypeRecommended = {};
      // --- Check Vehicle API ---
      if (vehicleResult && vehicleResult.isSuccess) {
        const vehicleId = vehicleResult.data?.vehicle?.id || "1002";
        vehicleTypeRecommended = vehicleResult.data?.vehicle || {};
        setVehicleId(vehicleId);
        handleUpdateBookingObject(
          "vehicleTypeId",
          vehicleId,
          "suggested_vehicle_success",
        );
        console.log("Vehicle updated successfully");
      } else {
        console.warn("Vehicle API failed, keeping previous or default.");
      }

      let labourRecommended = 2;
      // --- Check Labour API ---
      if (labourResult && labourResult.isSuccess) {
        labourRecommended = labourResult.data?.recommendedMovers || 2;

        const recommendedVehicle = vehicleResult?.data?.vehicle?.id;

        if (recommendedVehicle === 1004 || recommendedVehicle === 1005) {
          labourRecommended = Math.max(labourRecommended, 2);
        }

        handleUpdateBookingObject(
          "labourNeeded",
          labourRecommended,
          "suggested_labour_success",
        );
        console.log("Labour updated successfully");
      } else {
        console.warn("Labour API failed, keeping previous or default.");
      }

      handleEstimatePrice(labourRecommended, vehicleTypeRecommended);
    } catch (error) {
      console.error("Critical error in parallel calls:", error);
    } finally {
      setGeneralLoading(false);
    }
  };

  // Booking Create / Update Handler
  const handleBookingCreate = async () => {
    setGeneralLoading(true);
    try {
      const Booking_id = localStorage.getItem("bookingId");

      const payload = createBookingPayload();
      let response;

      // 1. API Call (Create or Update)
      if (!Booking_id) {
        response = await createVisionBooking(payload);
      } else {
        response = await updateVisionBooking(payload);
      }

      // API basic validation
      if (!response || !response.data) {
        throw new Error("API response empty or invalid");
      }

      const bookingData = response.data;

      const currentVBO = JSON.parse(localStorage.getItem("VBO") || "{}");

      const updatedVBO = {
        ...bookingData,
        exactTime: currentVBO?.exactTime || bookingData?.exactTime,
        deliveryDate: currentVBO?.deliveryDate || bookingData?.deliveryDate,
        SelectedVehicleName:
          currentVBO?.SelectedVehicleName || bookingData?.SelectedVehicleName,
        tripStatus: "Summary",
        isTruckRequired:
          bookingData?.isTruckRequired ?? currentVBO?.isTruckRequired ?? true,
      };

      localStorage.setItem("VBO", JSON.stringify(updatedVBO));
      setIsTruckRequired(
        bookingData?.isTruckRequired ?? currentVBO?.isTruckRequired ?? true,
      );

      if (typeof handleUpdateBookingObject === "function") {
        handleUpdateBookingObject(
          null,
          updatedVBO,
          "booking_create_update_success",
        );
      }

      if (bookingData.bookingId) {
        localStorage.setItem("bookingId", bookingData.bookingId.toString());
        // setBookingId(bookingData.bookingId);
      }

      refreshBookingTotalModel?.();

      showToast({
        type: "success",
        message: response.message || "Booking saved successfully!",
        duration: 4500,
      });

      return true;
    } catch (error) {
      console.error("CRITICAL ERROR IN handleBookingCreate:", error);

      showToast({
        type: "error",
        message: "Failed to save booking. Please try again.",
        duration: 4500,
      });

      return false;
    } finally {
      setGeneralLoading(false);
    }
  };

  const handleEstimatePrice = async (
    recommendedLabourCount = null,
    recommendedVehicle = null,
    delay = false,
  ) => {
    try {
      setEstimatePricingLoad(true);

      let response;

      if (recommendedLabourCount !== null || recommendedVehicle !== null) {
        response = await GetBookingPriceEstimate(
          recommendedLabourCount,
          recommendedVehicle,
        );
      } else {
        response = await GetBookingPriceEstimate(null, null, delay);
      }

      setEstimatePricing(response);
    } catch (error) {
      console.error("Error fetching price estimate:", error);
    } finally {
      setEstimatePricingLoad(false);
    }
  };

  //
  //
  // USE
  // EFFECT
  // ACTIONS
  //
  //

  const location = useLocation();
  const navigate = useNavigate();

  //This Useeffect is for Edit Booking Flow, it checks if mode is edit in query params and then fetches the booking from localStorage and updates the states and booking object accordingly
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const isEditMode = queryParams.get("mode") === "edit";

    if (isEditMode) {
      const savedVBO = JSON.parse(localStorage.getItem("VBO"));

      if (savedVBO) {
        const safeDeliveryDate = getEditModeDeliveryDate(
          savedVBO?.deliveryDate,
        );

        const updatedVBOForState = {
          ...savedVBO,
          tripStatus: "schedule",
          deliveryDate:
            safeDeliveryDate ||
            toDeliveryDateFormat(savedVBO?.deliveryDate) ||
            "",
        };
        handleUpdateBookingObject(
          null,
          updatedVBOForState,
          "booking_create_update_success",
        );
        localStorage.setItem("bookingId", JSON.stringify(savedVBO?.bookingId));

        setTripStatus("schedule");

        navigate("/", { replace: true });
      }
    }
  }, [location.search]);

  /// fetch Booking Modal function inside useEffect
  useEffect(() => {
    const fetchBookingTotalModel = async () => {
      try {
        setGeneralLoading(true);
        const visionReqId = Number(localStorage.getItem("visionReqId"));

        if (!visionReqId) {
          console.error("visionReqId not found in localStorage");
          return;
        }

        const bookingResponse = await getVisionBookingByVisionId(visionReqId);

        if (!bookingResponse?.data) {
          setGeneralLoading(false);
          console.error("Invalid booking response:", bookingResponse);
          return;
        }

        const updatedBookingTotalModel = bookingResponse.data.bookingTotalModel;

        if (!updatedBookingTotalModel) {
          console.error("bookingTotalModel not found in response");
          console.log("Full bookingResponse:", bookingResponse);
          return;
        }

        const existingVBO = JSON.parse(localStorage.getItem("VBO")) || {};
        existingVBO.bookingTotalModel = updatedBookingTotalModel;
        localStorage.setItem("VBO", JSON.stringify(existingVBO));
        console.log("bookingTotalModel updated, baki data same raha");
        setBookingTotalModel(updatedBookingTotalModel);
        setCompleteBookingObj(bookingResponse.data);
      } catch (error) {
        console.error("Error fetching bookingTotalModel:", error);
        setGeneralLoading(false);
      } finally {
        setGeneralLoading(false);
      }
    };

    fetchBookingTotalModel();
  }, [refreshTrigger]);

  // ✅ Manual trigger function For Latest Booking Total Model
  const refreshBookingTotalModel = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    handleEstimatePrice();
    try {
      updateUserCardStatus();
      let temp = localStorage.getItem(`VBO`);
      if (temp) {
        temp = JSON.parse(temp);

        // Check if booking data has expired before proceeding
        if (checkAndClearExpiredBooking(temp)) {
          // If booking expired, create new default booking
          const bookingWIthUpdatedType = {
            ...statesToBookingObj(),
          };

          generateBookingLogs(null, bookingWIthUpdatedType, "22", `VBO`);
          localStorage.setItem(`VBO`, JSON.stringify(bookingWIthUpdatedType));
          window.setTimeout(
            () => bookingObjToStates(bookingWIthUpdatedType),
            100,
          );
        } else {
          // Booking is valid, proceed as normal
          window.setTimeout(() => bookingObjToStates(temp), 100);
          if (["uploadimages", "visionItems"].includes(temp?.tripStatus)) {
            const visionReqId = localStorage.getItem("visionReqId");
            if (visionReqId) {
              setVisionProcessingStartTime(new Date().getTime());
              setVisionId(visionReqId);
            }
          }
        }
      } else {
        const bookingWIthUpdatedType = {
          ...statesToBookingObj(),
        };
        generateBookingLogs(null, bookingWIthUpdatedType, "22", `VBO`);
        localStorage.setItem(`VBO`, JSON.stringify(bookingWIthUpdatedType));
        window.setTimeout(
          () => bookingObjToStates(bookingWIthUpdatedType),
          100,
        );
      }

      // call all the APIs
      dispatch(getAllVehicles());
      dispatch(getAllDeliverySlots());
      dispatch(getMovingItems(setBookingItemsCatlog, setFrontItems));
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
    const hideLottie = setTimeout(() => {}, 3000);
    return () => {
      clearTimeout(hideLottie);
    };
  }, []);

  // useEffect to update vehicle counter
  useEffect(() => {
    try {
      if (vehicleTypesInfo?.length) {
        const visionVehicleId = localStorage.getItem("visionVehicle");
        if (visionVehicleId && !sliderVehicles?.length) {
          handlePopulateSliderVehicles(visionVehicleId, vehicleTypesInfo)
            .then((sortedVehicles) => {
              const index = sortedVehicles?.findIndex(
                (vehicle) => vehicle?.id === vehicleTypeId,
              );
              const ch_id = index >= 0 ? index : 0;
              let theDot = document.getElementById(`vehicleSliderDot${ch_id}`);
              theDot?.click();
            })
            .catch((e) => console.log(e));
          return;
        }
        if (vehicleTypeId) {
          handleSelectVehicleInSlider();
        } else {
          handleUpdateBookingObject(
            "vehicleTypeId",
            vehicleTypesInfo[0].id,
            "2",
          );
          let theDot = document.getElementById(`vehicleSliderDot0`).click();
        }
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [vehicleTypesInfo, vehicleId]);

  // Sync vehicleId to vehicleTypeId and booking object for immediate UI update after API call
  useEffect(() => {
    if (vehicleId && vehicleId !== vehicleTypeId) {
      handleUpdateBookingObject("vehicleTypeId", vehicleId, "vehicleId_sync");
    }
  }, [vehicleId]);

  useEffect(() => {
    if (tripStatus === "") {
      const vboString = localStorage.getItem("VBO");
      const vboObject = vboString ? JSON.parse(vboString) : null;
      setTripStatus(vboObject?.tripStatus || "uploadimages");
    }

    // Determine bookingStep index dynamically. If user is already logged in
    // and NOT just-registered-from-personal-info, skip the PersonalInfo step
    // so the indices shift left by one. If the user was just registered
    // (auto-login via verification), still include PersonalInfo for this flow.
    const isLoggedIn =
      Boolean(loginInfo?.id) && !justRegisteredFromPersonalInfo;
    const tripOrder = isLoggedIn
      ? [
          "uploadimages",
          "locations",
          "vehicle",
          "schedule",
          "ContactInfo",
          "Summary",
        ]
      : [
          "uploadimages",
          "locations",
          "vehicle",
          "schedule",
          "PersonalInfo",
          "ContactInfo",
          "Summary",
        ];

    let idx = 0;
    if (
      !tripStatus ||
      tripStatus === "uploadimages" ||
      tripStatus === "visionItems"
    ) {
      idx = 0;
    } else {
      const found = tripOrder.indexOf(tripStatus);
      idx = found >= 0 ? found : tripOrder.length - 1;
    }

    setBookingStep(idx);
  }, [tripStatus, loginInfo?.id, justRegisteredFromPersonalInfo]);

  // Enforce auth: if not logged in, do not allow flow past PersonalInfo
  useEffect(() => {
    const isAuthenticated = Boolean(loginInfo?.id);
    const protectedSteps = ["ContactInfo", "Summary"];

    if (!isAuthenticated && protectedSteps.includes(tripStatus)) {
      handleUpdateBookingObject("tripStatus", "PersonalInfo", "auth_guard");
    }
  }, [loginInfo?.id, tripStatus]);

  // Keep `isMapShown` consistent with the current booking step.
  // - On refresh while in "locations", we want to restore the last sub-view (map vs no-map).
  // - On any other step, force map off so footer/progress render correctly.
  useEffect(() => {
    try {
      // During initial mount we start with tripStatus === "" and then hydrate it
      // from localStorage. Don't override the persisted `isMapShown` in that window.
      if (tripStatus === "") return;

      if (tripStatus === "locations") {
        // If there's no stored preference yet (first time landing), default to map view.
        const stored = localStorage.getItem("isMapShown");
        if (stored == null) setIsMapShown(true);
      } else {
        setIsMapShown(false);
      }
    } catch (e) {
      // safest fallback: keep map hidden unless explicitly on locations
      if (tripStatus !== "" && tripStatus !== "locations") setIsMapShown(false);
    }
  }, [tripStatus, setIsMapShown]);

  // Persist the just-registered flag so a refresh keeps the PersonalInfo step visible
  useEffect(() => {
    try {
      if (justRegisteredFromPersonalInfo) {
        localStorage.setItem("just_registered", "true");
      } else {
        localStorage.removeItem("just_registered");
      }
    } catch (e) {
      console.error("Error persisting just_registered flag:", e);
    }
  }, [justRegisteredFromPersonalInfo]);

  useEffect(() => {
    dispatch(getAllVehicles());
  }, []);

  return (
    <>
      <div className="overflow-y-hidden">
        {/* Top Booking ProgressBar */}
        {!isMapShown ? (
          <div
            className={`px-[33px] max-w-container md:px-[10px] md:max-w-[900px] `}
          >
            <BookingProgress
              currentStep={bookingStep}
              // Combine 'Upload images' and 'Items' into a single step labeled 'Items'
              // If user is already logged in and NOT just-registered-from-personal-info,
              // hide the Personal info step. If user was just registered via phone
              // verification, still show Personal info for this flow.
              customSteps={
                Boolean(loginInfo?.id) && !justRegisteredFromPersonalInfo
                  ? [
                      "Items",
                      "Locations",
                      "Truck & crew",
                      "Date & Time",
                      "Contact info",
                      "Summary",
                    ]
                  : [
                      "Items",
                      "Locations",
                      "Truck & crew",
                      "Date & Time",
                      "Personal info",
                      "Contact info",
                      "Summary",
                    ]
              }
            />
          </div>
        ) : null}

        <div
          className={`bg-[#F6F6FD] overflow-y-auto ${
            tripStatus === "Summary"
              ? "h-[calc(100vh-144px)]"
              : isMobileDevice
                ? "h-[calc(100vh-268px)]"
                : "md:h-[calc(100vh-236px)] h-[calc(100vh-218px)]"
          }`}
        >
          <AddTextModal
            text={items[selectedBookingItemIndex]?.note}
            openState={openAddNoteModal}
            closeFunction={() => setOpenAddNoteModal(false)}
            btnText1={
              items[selectedBookingItemIndex]?.note ? "Edit note" : "Add note"
            }
            btnClickFunc1={addNoteBookingItem}
            btnText2={"Cancel"}
            label={
              items[selectedBookingItemIndex]?.note ? "Edit note" : "Add note"
            }
            placeholder={"i.e Fragile item"}
            btnClickFunc2={() => setOpenAddNoteModal(false)}
            handleRemoveNote={handleRemoveNote}
          />

          <ModalComponent
            text={"Please Enter Current or any Future Date.."}
            openState={Dateopen}
            closeFunction={handleDateClose}
            btnText1={"Ok"}
            btnClickFunc1={() => {
              setDateOpen(false);
            }}
          />
          <ModalComponent
            text={genericModalMessage}
            openState={showGenericModal}
            closeFunction={() => handleToggleGenericError()}
            btnText1={"OK"}
            btnClickFunc1={() => handleToggleGenericError()}
          />
          <ModalComponent
            text={
              "The processing took longer than expected, please try again..."
            }
            openState={showVisionTimeoutError}
            btnText1={"OK"}
          />

          {false ? null : ( // <LoadingLottie showPaymentMessage={showPaymentMessage} />
            <></>
          )}

          {/* Vision Booking Flow Screens  */}
          {tripStatus === "" || tripStatus === "uploadimages" ? (
            //  Document/Images Upload Screen  //
            <UploadImagesScreen
              handleUpdateBookingObject={handleUpdateBookingObject}
              setVisionId={setVisionId}
              setVisionItemsLoading={setVisionItemsLoading}
              setBookingTotalModel={setBookingTotalModel}
              setEstimatePricing={setEstimatePricing}
              setAddItems={setAddItems}
            />
          ) : tripStatus === "visionItems" ? (
            <VisionItemsScreen
              visionData={visionData}
              visionId={visionId}
              items={items}
              type={type}
              distanceInKm={distanceInKm}
              addItems={addItems}
              setAddItems={setAddItems}
              updateItemsAndTimestamp={updateItemsAndTimestamp}
              bookingItemsCatlog={bookingItemsCatlog}
              selectedBookingItemsFromCatlog={selectedBookingItemsFromCatlog}
              setSelectedBookingItemsFromCatlog={
                setSelectedBookingItemsFromCatlog
              }
              showPreview={showPreview}
              setShowPreview={setShowPreview}
              openAddNoteModal={openAddNoteModal}
              setOpenAddNoteModal={setOpenAddNoteModal}
              selectedBookingItemIndex={selectedBookingItemIndex}
              decrementBookingItem={decrementBookingItem}
              incrementBookingItem={incrementBookingItem}
              handleAddNote={handleAddNote}
              deleteBookingItem={deleteBookingItem}
              disassemblyRequiredBookingItem={disassemblyRequiredBookingItem}
              handleGetCatlogItems={handleGetCatlogItems}
              handleAddCatalogItems={handleAddCatalogItems}
              selectCatalogItem={selectCatalogItem}
              removeCatalogItem={removeCatalogItem}
              addNoteBookingItem={addNoteBookingItem}
              handleUpdateBookingObject={handleUpdateBookingObject}
              boxAndBagsCount={boxAndBagsCount}
              frontItems={frontItems}
            />
          ) : tripStatus === "locations" ? (
            // {/* Location Screen  */}
            <LocationScreen
              stops={stops}
              type={type}
              pickupLocation={pickupLocation}
              dropoffLocation={dropoffLocation}
              handleUpdateBookingObject={handleUpdateBookingObject}
              pickupLatitude={pickupLatitude}
              pickupLongitude={pickupLongitude}
              dropoffLatitude={dropoffLatitude}
              dropoffLongitude={dropoffLongitude}
              distanceInKm={distanceInKm}
              durationInMins={durationInMins}
              pickupMedium={pickupMedium}
              dropoffMedium={dropoffMedium}
              pickupNoOfStairs={pickupNoOfStairs}
              pickupNoOfFloors={pickupNoOfFloors}
              dropoffNoOfStairs={dropoffNoOfStairs}
              dropoffNoOfFloors={dropoffNoOfFloors}
              isTruckRequired={isTruckRequired}
              isLocationRouteComputing={isLocationRouteComputing}
              onRouteCalculationStatusChange={setIsLocationRouteComputing}
              history={history}
              handleBookingScreensNavigations={handleBookingScreensNavigations}
            />
          ) : tripStatus === "vehicle" ? (
            <VehicleScreen
              isTruckRequired={isTruckRequired}
              vehicleTypesInfo={vehicleTypesInfo}
              vehicleTypeId={vehicleTypeId}
              handleUpdateBookingObject={handleUpdateBookingObject}
              labourNeeded={labourNeeded}
              setIsNotATruckModalOpen={setIsNotATruckModalOpen}
              isNotATruckModalOpen={isNotATruckModalOpen}
              handleEstimatePrice={handleEstimatePrice}
              isTruckAndMooverWarningSeen={isTruckAndMooverWarningSeen}
              setIsTruckAndMooverWarningSeen={setIsTruckAndMooverWarningSeen}
            />
          ) : tripStatus === "schedule" ? (
            <DateAndTimeScreen
              deliveryDate={deliveryDate}
              exactTime={exactTime}
              type={type}
              handleUpdateBookingObject={handleUpdateBookingObject}
              deliverySlotsInfo={deliverySlotsInfo}
              handleBookingScreensNavigations={handleBookingScreensNavigations}
            />
          ) : tripStatus === "PersonalInfo" ? (
            <PersonalInfoScreen
              pickUpPersonName={pickUpPersonName}
              pickUpPersonPhone={pickUpPersonPhone}
              dropOffPersonName={dropOffPersonName}
              dropOffPersonPhone={dropOffPersonPhone}
              handleUpdateBookingObject={handleUpdateBookingObject}
              //Personal Info States

              firstName={firstName}
              lastName={lastName}
              email={email}
              phone={phone}
              setFirstName={setFirstName}
              setLastName={setLastName}
              setEmail={setEmail}
              setPhone={setPhone}
              setJustRegisteredFromPersonalInfo={
                setJustRegisteredFromPersonalInfo
              }
              justRegisteredFromPersonalInfo={justRegisteredFromPersonalInfo}
              loginInfo={loginInfo}
            />
          ) : tripStatus === "ContactInfo" ? (
            <div>
              <ContactInfoScreen
                pickUpInstructions={pickUpInstructions}
                setPickUpInstructions={setPickUpInstructions}
                setDropOffInstructions={setDropOffInstructions}
                dropOffInstructions={dropOffInstructions}
                dropOffPersonName={dropOffPersonName}
                errorObject={errorObject}
                pickUpPersonName={pickUpPersonName}
                pickUpPersonPhone={pickUpPersonPhone}
                stops={stops}
                dropoffLocation={dropoffLocation}
                dropOffPersonPhone={dropOffPersonPhone}
                setErrorObject={setErrorObject}
                handleUpdateBookingObject={handleUpdateBookingObject}
              />
            </div>
          ) : tripStatus === "Summary" ? (
            <SummaryScreen
              exactTime={exactTime}
              deliveryDate={deliveryDate}
              dropOffPersonName={dropOffPersonName}
              dropOffPersonPhone={dropOffPersonPhone}
              pickUpPersonName={pickUpPersonName}
              pickUpPersonPhone={pickUpPersonPhone}
              pickUpInstructions={pickUpInstructions}
              dropOffInstructions={dropOffInstructions}
              pickupLocation={pickupLocation}
              stops={stops}
              dropoffLocation={dropoffLocation}
              items={items}
              handleUpdateBookingObject={handleUpdateBookingObject}
              setBookingTotalModel={setBookingTotalModel}
              handleEstimatePrice={handleEstimatePrice}
              /// Payment Screen Props

              type={type}
              bookingTotalModel={bookingTotalModel}
              distanceInKm={distanceInKm}
              statesToBookingObj={statesToBookingObj}
              userInfo={loginInfo}
              coupon={coupon}
              setShowPaymentMessage={setShowPaymentMessage}
              visionId={visionId}
              refreshBookingTotalModel={refreshBookingTotalModel}
              completeBookingObj={completeBookingObj}
            />
          ) : null}
        </div>

        {!isMapShown ? (
          <NavigationWithEstimate
            tripStatus={tripStatus}
            handleUpdateBookingObject={handleUpdateBookingObject}
            handleNextClickValidations={handleNextClickValidations}
            setIsBottomSheetOpen={setIsBottomSheetOpen}
            loginInfo={loginInfo}
            justRegisteredFromPersonalInfo={justRegisteredFromPersonalInfo}
            setJustRegisteredFromPersonalInfo={
              setJustRegisteredFromPersonalInfo
            }
            isNextButtonDisabled={
              ((firstName.trim() === "" ||
                lastName.trim() === "" ||
                email.trim() === "" ||
                phone.trim() === "") &&
                tripStatus === "PersonalInfo") ||
              (tripStatus === "locations" && isLocationRouteComputing)
            }
            isBackButtonDisabled={false}
            onClickHandleSuggestedVehicleAndLabour={
              handleSuggestedVehicleAndLabour
            }
            onClickHandleSaveImagesToBackend={handleSaveImagesToBackend}
            onClickHandleBookingCreate={handleBookingCreate}
            estimatePricing={estimatePricing}
            estimatePricingLoad={estimatePricingLoad}
          />
        ) : null}

        <ReusableModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          showLoading={visionItemsLoading}
        />

        {/* Booking total modal Bottom Modal Blue Color */}
        <BookingTotal
          estimatePricing={estimatePricing}
          type={type}
          distanceInKm={distanceInKm}
          isBottomSheetOpen={isBottomSheetOpen}
          setIsBottomSheetOpen={setIsBottomSheetOpen}
        />

        <NoBoxesAndBagsWarningModal
          open={noBoxesAndBagsWarningModalOpen}
          onClose={() => setNoBoxesAndBagsWarningModalOpen(false)}
          handleUpdateBookingObject={handleUpdateBookingObject}
          handleSaveImagesToBackend={handleSaveImagesToBackend}
        />

        {tripStatus === "" && (
          <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-[#7876A1]/50 backdrop-blur-sm">
            <LoadingMoveez text="Loading....." isLoadingShow={true} />
          </div>
        )}

        {isNotATruckModalOpen && (
          <NotATruckModal
            isNotATruckModalOpen={isNotATruckModalOpen}
            onClose={() => setIsNotATruckModalOpen(false)}
          />
        )}

        <BookOneMoverWarnModal
          open={bookOneMoverWarnModalOpen}
          onClose={() => setBookOneMoverWarnModalOpen(false)}
          handleUpdateBookingObject={handleUpdateBookingObject}
          setLabourNeeded={setLabourNeeded}
          handleEstimatePrice={handleEstimatePrice}
        />
      </div>
      {/* //general Loading  */}
      <LoadingMoveez
        text="Please wait, we're on it!"
        isLoadingShow={generalLoading}
        isGeneralLoading={true}
      />
    </>
  );
};

export default Booking;
